import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import semenStockListAction from './semenStockList.action.json' with { type: 'json' }
import { semenStockObject } from '../semenStockObject'

export const semenStockExpression = expression(semenStockObject.shape)

const semenStockListDefinition = defineAction({
  ...semenStockListAction,

  input: z.object({
    filter: semenStockExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      buyDate: 'Data de compra',
      quantity: 'Quantidade',
      type: 'Tipo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
    monthlyActive: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(semenStockObject),
    count: z.number(),
    activeMonths: z.array(z.string()).nullish(),
  }),
})

export default semenStockListDefinition
